
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getWorkorderpaymentTypes} from 'sr/utils/api/masterData/workorderpaymentTypes/getWorkorderpaymentTypes'
export const fetchworkorderpaymentTypes = createAsyncThunk(
  'getWorkorderpaymentTypes',
  async () => {
    const response = await getWorkorderpaymentTypes()
    return response?.data
  }
)


